<template>
  <div class="login-page">
    <div class="login-gradient">
      <div class="login-logo-wrapper">
        <img class="login-logo" src="../assets/Logo-sk.png" alt="Super Kompras" />
      </div>

      <div class="login-card-custom shadow-lg">
        <h2 class="login-title">Iniciar Sesión</h2>
        <p class="login-subtitle">Ingresa tu correo y contraseña</p>

        <div v-if="error" class="login-alert login-alert-error" role="alert">
          <i class="fa-solid fa-circle-exclamation"></i>
          <span>{{ error }}</span>
        </div>

        <form @submit.prevent="doLogin">
          <div class="mb-3">
            <label class="form-label">Correo Electrónico</label>
            <input v-model="email" type="email" class="form-control login-input"
              placeholder="Ingresa tu correo electrónico" required />
          </div>

          <div class="mb-3">
            <label class="form-label">Contraseña</label>
            <div class="position-relative">
              <input v-model="password" :type="type" class="form-control login-input"
                placeholder="Ingresa tu contraseña" required />
              <button type="button" class="btn btn-link login-show-password" @click="showPassword">
                {{ type === 'password' ? 'Mostrar' : 'Ocultar' }}
              </button>
            </div>
          </div>

          <router-link :to="{ name: 'recuperar-contrasena', query: email ? { correo: email } : {} }" class="login-link">
            ¿Olvidaste tu contraseña?
          </router-link>

          <button type="submit" class="btn btn-login w-100 mt-3" :disabled="loading">
            {{ loading ? 'Accediendo...' : 'Acceder' }}
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoginPage",
  data() {
    return {
      type: "password",
      email: "",
      password: "",
      loading: false,
      error: "",
    };
  },
  methods: {
    showPassword() {
      this.type = this.type === "password" ? "text" : "password";
    },
    async doLogin() {
      this.error = "";
      if (!this.email || !this.password) {
        this.error = "Debes ingresar correo y contraseña";
        return;
      }

      this.loading = true;
      try {
        await this.$store.dispatch("autenticacion/iniciarSesion", {
          correo: this.email,
          contraseña: this.password,
        });
        await this.$store.dispatch("autenticacion/consultarRoles");
        this.$store.dispatch("menu/actualizarMenuPorRol");

        this.$router.replace("/dashboard");
      } catch (error) {
        this.error = error.msg || "No se pudo iniciar sesión. Verifica tu conexión con el servidor.";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, #f7f7ff 0%, #6f6cfb 100%);
}

.login-gradient {
  width: 100%;
  max-width: 100%;
  padding: 40px 16px 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.login-logo-wrapper {
  margin-bottom: 32px;
}

.login-logo {
  max-width: 260px;
  height: auto;
}

.login-card-custom {
  background: #ffffff;
  border-radius: 24px;
  padding: 40px 48px 36px;
  max-width: 480px;
  width: 100%;
}

.login-title {
  font-size: 28px;
  font-weight: 700;
  text-align: center;
  margin-bottom: 8px;
  color: #222222;
}

.login-subtitle {
  text-align: center;
  margin-bottom: 24px;
  color: #8a8ba0;
}

.login-input {
  border-radius: 999px;
  padding: 10px 18px;
  border: 1px solid #e0e0f0;
  box-shadow: none;
}

.login-input:focus {
  border-color: #6f6cfb;
  box-shadow: 0 0 0 0.1rem rgba(111, 108, 251, 0.25);
}

.login-show-password {
  position: absolute;
  right: 18px;
  top: 50%;
  transform: translateY(-50%);
  padding: 0;
  font-size: 0.875rem;
  text-decoration: none;
  color: #6f6cfb;
}

.login-show-password:hover {
  text-decoration: underline;
}

.login-alert {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 14px 16px;
  margin-bottom: 20px;
  border-radius: 10px;
  color: #ffffff;
  font-size: 0.95rem;
  line-height: 1.4;
}

.login-alert i {
  margin-top: 3px;
}

.login-alert-error {
  background: #ff4b7b;
}

.login-link {
  display: inline-block;
  font-size: 0.9rem;
  text-decoration: none;
  color: #6f6cfb;
}

.login-link:hover {
  text-decoration: underline;
}

.btn-login {
  border-radius: 999px;
  background: #6f6cfb;
  border-color: #6f6cfb;
  color: #ffffff;
  font-weight: 600;
  padding: 10px 16px;
}

.btn-login:hover,
.btn-login:focus-visible,
.btn-login:active {
  background: #5c59e8;
  border-color: #5c59e8;
  color: #ffffff;
}

.btn-login:disabled {
  opacity: 0.7;
}

@media (max-width: 576px) {
  .login-card-custom {
    padding: 28px 20px 24px;
    border-radius: 16px;
  }

  .login-logo {
    max-width: 200px;
  }
}
</style>
